import {helpers} from "@vuelidate/validators"

export const strongRegexValidator =  helpers.regex(/^(?=.*[!@#$%^&*()_-])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/)

export default {
	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
	data() {
		return {
            strongRegex: "^(?=.*[!@#$%^&*()_-])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})",
            passwordPolicy: [
                "Minimum 8 characters",
                "At least one uppercase",
                "At least one number",
                "At least one symbol !@#$%^&*()_-"
            ],
		}
	},
};